import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Data } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { Subscription } from 'rxjs/Rx';
import { ErrorHandlerService } from '../../services';
import { ConfirmationService } from 'primeng/primeng';
import { PaymentHelper } from '../commons/helper/payment';
import { LoginService } from "../../login";
import * as moment from 'moment';
var SessionquestionnaireComponent = /** @class */ (function () {
    function SessionquestionnaireComponent(data, dashboardService, errorHandlerService, confirmationService, loginService, paymentHelper, router, route, fb) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.confirmationService = confirmationService;
        this.loginService = loginService;
        this.paymentHelper = paymentHelper;
        this.router = router;
        this.route = route;
        this.fb = fb;
        this.subscriptions = [];
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorMessageTitle = "";
        this.showErrorMessages = [];
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = false;
        this.isSignUp = true;
        this.pleaseWait = true;
        this.query = 0;
        this.isInvalid = false;
        this.courseDetail = {};
        this.isAns = false;
        this.userId = 0;
        this.isPaid = false;
        this.isPreview = false;
        if (localStorage.getItem("isPaidSession") == "true") {
            this.isPaid = true;
        }
        this.questionnaireForm = this.fb.group({
            description: null,
            questionnaireType: null,
            questionnaireTargetId: null,
            questionnaireId: null,
            responses: this.fb.array([]),
        });
    }
    SessionquestionnaireComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    SessionquestionnaireComponent.prototype.ngOnInit = function () {
        this.showSpinner = true;
        if (this.route.snapshot.params.userId && this.route.snapshot.params.queId) {
            this.userId = this.route.snapshot.params.userId;
            this.query = this.route.snapshot.params.queId;
            this.isAns = true;
            this.isPreview = false;
            this.ansFn();
        }
        else if (this.route.snapshot.params.queId) {
            this.query = this.route.snapshot.params.queId;
            this.isAns = false;
            this.isPreview = false;
            this.queFn();
        }
        else if (this.data.storage.coursepreview.coursedata.registrationQuestionnaireId) {
            this.query = this.data.storage.coursepreview.coursedata.registrationQuestionnaireId;
            this.isAns = false;
            this.isPreview = true;
            this.queFn();
        }
    };
    SessionquestionnaireComponent.prototype.ansFn = function () {
        var _this = this;
        if (this.query > 0 && this.userId > 0) {
            var s1 = this.dashboardService.getQuestionnaireAns(this.query, this.userId).subscribe(function (data) {
                var _a;
                console.log('questionnaireData', data);
                _this.showSpinner = false;
                _this.questionnaireForm.get("description").setValue(data.description);
                _this.questionnaireForm.get("questionnaireType").setValue(data.questionnaireType);
                _this.questionnaireForm.get("questionnaireTargetId").setValue(data.questionnaireTargetId);
                _this.questionnaireForm.get("questionnaireId").setValue(data.objId);
                for (var i = 0; i < data.responses.length; i++) {
                    _this.questions().push(_this.fb.group({
                        number: data.responses[i].number,
                        question: data.responses[i].question,
                        answerTypeCode: data.responses[i].answerTypeCode,
                        options: _this.fb.array([]),
                        maxLength: data.responses[i].maxLength,
                        maxRating: (data.responses[i].answerTypeCode == 6) ? data.responses[i].answer : data.responses[i].maxRating,
                        optional: data.responses[i].optional,
                        answer: (data.responses[i].answerTypeCode == 7 && data.responses[i].answer != null && data.responses[i].answer != "") ? _this.changeDateFormat(data.responses[i].answer) : data.responses[i].answer,
                        invalid: false
                    }));
                    if (data.responses[i].options != null && data.responses[i].options.length > 0) {
                        for (var j = 0; j < data.responses[i].options.length; j++) {
                            console.log(data.responses[i].options[j].value, data.responses[i].options[j].selected);
                            _this.getOptions(i).push(_this.fb.group((_a = {
                                    value: data.responses[i].options[j].value
                                },
                                _a['selected_' + j] = data.responses[i].options[j].selected,
                                _a)));
                        }
                    }
                }
                console.log("this.questionnaireForm", _this.questionnaireForm);
                _this.disableAllFields(_this.questionnaireForm);
                _this.disableAllFields(_this.questionnaireForm.get("responses"));
                for (var q = 0; q < _this.questions().length; q++) {
                    for (var index = 0; index < _this.getOptions(q).length; index++) {
                        _this.disableAllFields(_this.questions().at(q).get("options"));
                    }
                }
                console.log('form', _this.questionnaireForm.value);
            }, function (error) {
                _this.handleError(error);
            });
            this.subscriptions.push(s1);
        }
    };
    SessionquestionnaireComponent.prototype.queFn = function () {
        var _this = this;
        if (this.query != 0) {
            var s1 = this.dashboardService.getQuestionnaire(this.query).subscribe(function (data) {
                console.log('questionnaireData', data);
                _this.showSpinner = false;
                _this.questionnaireForm.get("description").setValue(data.description);
                _this.questionnaireForm.get("questionnaireType").setValue(data.questionnaireType);
                _this.questionnaireForm.get("questionnaireTargetId").setValue(data.questionnaireTargetId);
                _this.questionnaireForm.get("questionnaireId").setValue(data.objId);
                for (var i = 0; i < data.questions.length; i++) {
                    _this.questions().push(_this.fb.group({
                        number: data.questions[i].number,
                        question: data.questions[i].question,
                        answerTypeCode: data.questions[i].answerTypeCode,
                        options: _this.fb.array([]),
                        maxLength: data.questions[i].maxLength,
                        maxRating: data.questions[i].maxRating,
                        optional: data.questions[i].optional,
                        answer: (!data.questions[i].optional && (data.questions[i].answerTypeCode == 1 ||
                            data.questions[i].answerTypeCode == 6 ||
                            data.questions[i].answerTypeCode == 7)) ? [null, [Validators.required]] : null,
                        invalid: false
                    }));
                    if (data.questions[i].options != null && data.questions[i].options.length > 0) {
                        for (var j = 0; j < data.questions[i].options.length; j++) {
                            _this.getOptions(i).push(_this.fb.group({
                                value: data.questions[i].options[j],
                                selected: (data.questions[i].answerTypeCode == 4 && j == 0) ? true : false
                            }));
                        }
                    }
                }
                console.log('form', _this.questionnaireForm.value);
            }, function (error) {
                _this.handleError(error);
            });
            this.subscriptions.push(s1);
        }
    };
    SessionquestionnaireComponent.prototype.questions = function () {
        return this.questionnaireForm.get("responses");
    };
    SessionquestionnaireComponent.prototype.getOptions = function (queIndex) {
        return this.questions().at(queIndex).get("options");
    };
    SessionquestionnaireComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.isAns) {
            this.isInvalid = false;
            if (this.questionnaireForm.valid) {
                this.checkValidation();
                for (var i = 0; i < this.questionnaireForm.value.responses.length; i++) {
                    if (this.questionnaireForm.value.responses[i].invalid) {
                        this.isInvalid = true;
                        break;
                    }
                }
                if (!this.isInvalid && !this.isPaid) {
                    this.showSpinner = true;
                    console.log('form', this.questionnaireForm.value);
                    this.dashboardService.registerQuestionnaireCourseFree(this.questionnaireForm.value.questionnaireTargetId, this.questionnaireForm.value).subscribe(function (data) {
                        console.log(data);
                        if (data.errorMsg == null) {
                            _this.freeRegisterSuccessful();
                        }
                        else {
                            _this.createInfoAlert(data.errorMsg);
                        }
                    }, function (error) {
                        _this.showSpinner = false;
                        _this.handleError(error);
                    });
                }
                else if (!this.isInvalid && this.isPaid) {
                    localStorage.removeItem("questionnaireResponse");
                    localStorage.setItem("questionnaireResponse", JSON.stringify(this.questionnaireForm.value));
                    this.router.navigate(['dashboard/registersession'], { queryParams: { courseId: this.questionnaireForm.value.questionnaireTargetId } });
                }
            }
            else {
                this.validateAllFields(this.questionnaireForm);
                this.validateAllFields(this.questionnaireForm.get("responses"));
                for (var q = 0; q < this.questions().length; q++) {
                    for (var index = 0; index < this.getOptions(q).length; index++) {
                        this.validateAllFields(this.questions().at(q).get("options"));
                    }
                }
                this.checkValidation();
            }
        }
    };
    SessionquestionnaireComponent.prototype.freeRegisterSuccessful = function () {
        var _this = this;
        this.dashboardService.getCourse(this.questionnaireForm.value.questionnaireTargetId).subscribe(function (data) {
            _this.courseDetail = data;
            _this.showSpinner = false;
            var encodedCourseName = btoa(_this.courseDetail.courseFullName);
            _this.router.navigate(['dashboard/myenrollment'], { queryParams: { success: encodedCourseName } });
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
    };
    SessionquestionnaireComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    SessionquestionnaireComponent.prototype.checkValidation = function () {
        for (var i = 0; i < this.questionnaireForm.value.responses.length; i++) {
            if (this.questionnaireForm.value.responses[i].options.length > 0 && !this.questionnaireForm.value.responses[i].optional) {
                for (var j = 0; j < this.questionnaireForm.value.responses[i].options.length; j++) {
                    if (this.questionnaireForm.value.responses[i].options[j].selected) {
                        this.questions().at(i).get("invalid").setValue(false);
                        break;
                    }
                    else {
                        this.questions().at(i).get("invalid").setValue(true);
                    }
                }
            }
        }
    };
    SessionquestionnaireComponent.prototype.dropdownChange = function (que, e) {
        for (var j = 0; j < this.questionnaireForm.value.responses[que].options.length; j++) {
            if (this.questionnaireForm.value.responses[que].options[j].value == e.target.value) {
                this.questionnaireForm.value.responses[que].options[j].selected = true;
            }
            else {
                this.questionnaireForm.value.responses[que].options[j].selected = false;
            }
        }
    };
    SessionquestionnaireComponent.prototype.radioChange = function (que, e) {
        this.questions().at(que).get("invalid").setValue(false);
        for (var j = 0; j < this.questionnaireForm.value.responses[que].options.length; j++) {
            if (this.questionnaireForm.value.responses[que].options[j].value == e.target.value) {
                this.questionnaireForm.value.responses[que].options[j].selected = true;
            }
            else {
                this.questionnaireForm.value.responses[que].options[j].selected = false;
            }
        }
    };
    SessionquestionnaireComponent.prototype.changeCheckBox = function (option, question) {
        this.questions().at(question).get("invalid").setValue(false);
        for (var j = 0; j < this.questionnaireForm.value.responses[question].options.length; j++) {
            if (j != option) {
                this.getOptions(question).at(j).get("selected").setValue(false);
            }
        }
    };
    SessionquestionnaireComponent.prototype.validateAllFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                _this.validateAllFields(control);
            }
        });
    };
    SessionquestionnaireComponent.prototype.disableAllFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.disable();
            }
            else if (control instanceof FormGroup) {
                _this.disableAllFields(control);
            }
        });
    };
    SessionquestionnaireComponent.prototype.changeDateFormat = function (d) {
        console.log("toDate();", d);
        var dd = new Date(d);
        console.log("moment(Date, 'mm/dd/yy').toDate();", moment(dd, 'MM/DD/YYYY').toDate());
        return moment(dd, 'MM/DD/YYYY').toDate();
    };
    SessionquestionnaireComponent.prototype.getCount = function (max, char) {
        var charLen = (char == null) ? 0 : char.length;
        return max - charLen;
    };
    SessionquestionnaireComponent.prototype.roundValue = function (input) {
        return Math.floor(input);
    };
    SessionquestionnaireComponent.prototype.handleError = function (error) {
        //console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        //console.log("The URL of the error==>"+error.url);
        if (url == undefined) {
            return;
        }
        //console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    SessionquestionnaireComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return SessionquestionnaireComponent;
}());
export { SessionquestionnaireComponent };
//# sourceMappingURL=sessionquestionnaire.component.js.map